<div class="slide" [class.large]="large()" [style.background]="bgColor()" [style.border-color]="borderColor()">
  <div class="content">
    @if (title() && description()) {
      <div class="title">{{ title() }}</div>
      <div class="description">{{ description() }}</div>
    } @else if (htmlContent()) {
      <div [innerHTML]="safeHTML!"></div>
    }
  </div>
  @if (imageSrc()) {
    <div class="circle-wrapper">
      <div class="circle-dash dash-1" [style.border-color]="dashColor()"></div>
      <div class="circle-dash dash-2" [style.border-color]="dashColor()"></div>
      <div class="circle-dash dash-3" [style.border-color]="dashColor()"></div>
      <img class="circle-image" [src]="imageSrc()" />
    </div>
  }
</div>